module.exports = __webpack_public_path__ + "static/media/history.deb61157.svg";